import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { LinkToParam } from "../components/ui/Link";
import { path, serverResponsePaths } from "../paths";
import { useAuthentication } from "../providers/AuthenticationProvider";

export default function useRedirect() {
  const navigate = useNavigate();
  const { user } = useAuthentication();

  const redirect = useCallback(
    (to: LinkToParam) => {
      const destination = typeof to === "string" ? to : path(...to);
      const needsServerResponse =
        typeof to === "string" || Object.keys(serverResponsePaths).includes(to[0] as keyof typeof serverResponsePaths);

      console.log("Redirecting to", to);
      // Target will be a path if it is on the same domain, otherwise it will be a URL
      if (destination.startsWith("/") && !needsServerResponse) return navigate(destination);
      if (
        destination.startsWith(location.origin) ||
        typeof to === "string" ||
        !destination.startsWith("http") ||
        to[0].startsWith("up.") ||
        !user
      ) {
        location.href = destination;
        return;
      }

      location.href = path("up.auth.loginRedirect", { redirectUrl: destination });
    },
    [navigate, user],
  );

  return redirect;
}

type Props = {
  to: LinkToParam;
};

export function Redirect({ to }: Props): React.ReactElement {
  const redirect = useRedirect();

  useEffect(() => {
    redirect(to);
  }, [to, redirect]);

  return <></>;
}
